import { module } from 'modujs';
import Env from '../base/env';

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };
    if (Env.mobileCSS == true) {
      if (this.$('data_1')[0] != null) {
        this.$('data_1')[0].appendChild(this.$('glue_1')[0]);
      }
      if (this.$('data_2')[0] != null) {
        this.$('data_2')[0].appendChild(this.$('glue_2')[0]);
      }
    }
  }
}
